import React from "react";


const Checkbox = props => {
    let inputClassName = props.inputClassName ? "cdx-input " + props.inputClassName : "cdx-input";
    let className = props.className ? "checkbox " + props.className : "checkbox ";

    return <div className={className}>
        <label className="checkbox-container">
            <input type="checkbox" {...props} className={inputClassName} />
            {props.label}
            <span className="checkmark"></span>
        </label>
    </div>;

};

export default Checkbox;